import React, { useState } from "react";
import { Button } from "@amzn/awsui-components-react";
import { downloadTieOutResults } from "./tieOutPdfUtils";

const DownloadTieOutResultsButton = ({ data }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!data) return;
    await downloadTieOutResults(
      data,
      () => setIsDownloading(true),
      () => setIsDownloading(false)
    );
  };

  return (
    <Button
      iconName="download"
      variant="icon"
      onClick={handleDownload}
      disabled={isDownloading}
      loading={isDownloading}
    />
  );
};

export default DownloadTieOutResultsButton;
